import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { FeatureIconComponent } from '../../../components/feature-icon/feature-icon.component';

@Component({
    selector: 'bg-packages-confirm',
    templateUrl: 'packages-cashout.component.html',
    imports: [CommonModule, FeatureIconComponent],
})
export class PackagesCashoutComponent implements OnInit {
    content: any;
    gamefeatureData: any;
    featureContent: string;
    featureTitle: string;
    clientConfig: any;

    constructor(
        public dialogRef: MatDialogRef<PackagesCashoutComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {}
    ngOnInit() {
        this.clientConfig = JSON.parse(localStorage.getItem('config')!);
        this.content = this.clientConfig?.packageGlobalMessages;
        this.gamefeatureData = this.data.gamefeatureData;
        this.featureTitle = this.clientConfig?.packageGlobalMessages[this.data.gamefeatureData + '_title'];
        this.featureContent = this.clientConfig?.packageGlobalMessages[this.data.gamefeatureData + '_content'];
    }

    close() {
        this.dialogRef.close();
    }
}
